import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PaymentType} from "../payment-type/payment-type";

@Component({
  selector: 'app-credit-card-select',
  templateUrl: './credit-card-select.component.html',
  styleUrls: [
    './credit-card-select.component.scss',
    '../payment-type/payment-type.component.scss',
    '../../shipping-method/delivery-select/delivery-select.component.scss'
  ]
})
export class CreditCardSelectComponent {

  @Input() isSelected: boolean = false;
  @Input() inputName: string = 'credit-card-select'
  @Input() creditCardLast4Numbers: string = '1111';
  @Input() paymentType: PaymentType = PaymentType.CREDIT_CARD;

  @Output() selected: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() deleteCreditCard: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }

  protected select(): void {
    this.isSelected = true;
    this.selected.emit(this.isSelected);
  }
}
